import $ from 'jquery';

import '../bundles/northstar';
import cmsIconFix from '../components/cms-icon-fix';
import externalLinks from '../components/external-links';
import hp from '../init/hp';
import hpNav from '../components/hp-nav';
import makeGoodHappen from '../widgets/make-good-happen';
import planFinder from '../webapps/plan-finder';
import navigationActive from '../utils/navigation-active';
import browserAlert from '../utils/browser-alert';

import '../../scss/northstar/public/public.scss';

window.hp = hp();
window.hp.nav = hpNav;

$(document).ready(function() {
  window.hp.nav();

  cmsIconFix();
  externalLinks();
  makeGoodHappen();
  planFinder();
  navigationActive();
  browserAlert(window.hp);
});



// WEBPACK FOOTER //
// ./src/webpack/bundles/hp.js